var _rect, _path, _rect2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#222222"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8338 19.6281C34.8376 17.6243 38.0863 17.6243 40.09 19.6281C42.0937 21.6318 42.0937 24.8805 40.09 26.8842L36.647 30.3272C36.2565 30.7177 35.6233 30.7177 35.2328 30.3272C34.8423 29.9367 34.8423 29.3035 35.2328 28.913L38.6758 25.47C39.8985 24.2473 39.8985 22.265 38.6758 21.0423C37.4531 19.8196 35.4707 19.8196 34.2481 21.0423L30.8051 24.4853C30.4145 24.8758 29.7814 24.8758 29.3908 24.4853C29.0003 24.0948 29.0003 23.4616 29.3908 23.0711L32.8338 19.6281Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 25,
    width: 2.06544,
    height: 11.0157,
    rx: 1,
    transform: "rotate(45 33 25)",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4854 28.3907C25.876 28.7812 25.876 29.4144 25.4854 29.8049L22.0424 33.2479C20.8198 34.4706 20.8198 36.4529 22.0424 37.6756C23.2651 38.8983 25.2475 38.8983 26.4702 37.6756L29.9132 34.2326C30.3037 33.8421 30.9368 33.8421 31.3274 34.2326C31.7179 34.6232 31.7179 35.2563 31.3274 35.6469L27.8844 39.0898C25.8806 41.0936 22.632 41.0936 20.6282 39.0898C18.6245 37.0861 18.6245 33.8374 20.6282 31.8337L24.0712 28.3907C24.4617 28.0002 25.0949 28.0002 25.4854 28.3907Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyLink);
export default __webpack_public_path__ + "static/media/copy_link.24ec3ae006dcad095a408e409c63ecc1.svg";
export { ForwardRef as ReactComponent };